var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcosystemCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 90,
    viewBox: "0 0 559 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 89H59.1302C52.9496 89 47.0072 86.6156 42.5408 82.3434L33.4592 73.6566C28.9928 69.3844 23.0504 67 16.8698 67H0V24C0 10.7452 10.7452 0 24 0H535C548.255 0 559 10.7452 559 24V67H534.441C528.076 67 521.971 69.5286 517.471 74.0294L509.529 81.9706C505.029 86.4714 498.924 89 492.559 89H279.5Z",
    fill: "#0E0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67L16.8698 67C23.0504 67 28.9928 69.3844 33.4592 73.6566L42.5408 82.3434C47.0072 86.6156 52.9496 89 59.1302 89H279.5H492.559C498.924 89 505.029 86.4714 509.529 81.9706L517.471 74.0294C521.971 69.5286 528.076 67 534.441 67L559 67",
    stroke: " #474747",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemCurve);
export default __webpack_public_path__ + "static/media/ecosystem-curve.786d45726d621b2a625ee5d51cd5fb61.svg";
export { ForwardRef as ReactComponent };